import * as React from 'react';
import { Alert, ListGroup, Spinner } from 'react-bootstrap';
import {
  EventSeriesReconciliationAudit,
  formatEventSeriesReconciliationOperation,
  formatEventSeriesReconciliationOutcome,
  formatEventSeriesReconciliationScope,
} from 'cb-model';
import { Section, useCacheQuery } from 'gossamer-front-end';
import { displayDateTimeToMinute, getFilter } from 'gossamer-unified';

export const SeriesReconciliationHistorySection = ({ repeatGroupId }: { repeatGroupId: string }): React.JSX.Element => {
  const auditRecords = useCacheQuery(EventSeriesReconciliationAudit, {
    where: { and: [getFilter('repeat_group_id', 'eq', repeatGroupId)] },
    order: [['performed_at', 'DESC']],
  });

  return (
    <Section title="Series History" subtitle="Completed series-wide reconciliation actions">
      {auditRecords.isFetching && !auditRecords.data && <Spinner animation="border" size="sm" />}
      {auditRecords.error && <Alert variant="danger">Unable to load series history.</Alert>}
      {!auditRecords.error && !auditRecords.isFetching && !auditRecords.data?.length && (
        <Alert variant="light">No series-wide changes have been recorded.</Alert>
      )}
      {!!auditRecords.data?.length && (
        <ListGroup>
          {auditRecords.data.map((record) => (
            <ListGroup.Item key={record.id}>
              <div className="fw-semibold">{formatEventSeriesReconciliationOperation(record.operation_type)}</div>
              <div className="small text-muted">
                {formatEventSeriesReconciliationScope(record.scope)}
                {record.effective_from ? ` · effective ${displayDateTimeToMinute(record.effective_from)}` : ''}
                {` · ${displayDateTimeToMinute(record.performed_at)}`}
              </div>
              <div className="small">{formatEventSeriesReconciliationOutcome(record.outcome_summary)}</div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </Section>
  );
};
